/** @format */
import { post, download } from '@root/utils/httpWrap';

// import { AxiosPromise } from 'axios'
// import { setHttp } from '../../../utils/http'
// const http = setHttp({}, '')
function transformParam(p: any) {
  return {
    ...p
  };
}
/**
 * 监控规则-监控规则单记录查询
 */
export const querygetRuleMonitoringById = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseRuleMonitoring/getRuleMonitoringById', transformParam(params));
};
/**
 * 监控规则-监控规则列表(条件)查询
 */
export const queryserchRuleMonitoring = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseRuleMonitoring/serchRuleMonitoring', transformParam(params));
};
/**
 * 监控规则-监控规则起停用
 */
export const querychangeStatus = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseRuleMonitoring/changeStatus', transformParam(params));
};
/**
 * 监控规则-监控规则删除
 */
export const deleteStatus = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseRuleMonitoring/delete', transformParam(params));
};
/**
 * 监控规则-监控类型/事件 列表查询(全量,给页面中下拉框展示)
 */
export const getRuleMonitoringEvent = (params?: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseRuleMonitoring/getRuleMonitoringEvent', transformParam(params));
};
/**
 * 监控规则-监控事件记录列表(条件)查询
 */
export const queryserchRuleMonitoringRecord = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseRuleMonitoring/serchRuleMonitoringRecord', transformParam(params));
};
/**
 * 监控规则-监控事件记录已读操作
 */
export const queryisRead = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseRuleMonitoring/isRead', transformParam(params));
};
/**
 * 监控规则-监控规则配置新增
 */
export const setCreateMonitor = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseRuleMonitoring/createMonitor', transformParam(params));
};
/**
 * 监控规则-监控规则配置更改
 */
export const addUpdateMonitor = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseRuleMonitoring/updateMonitor', transformParam(params));
};
/**
 * 监控规则-适用车场范围
 */
export const applyParkByMonitorId = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseRuleMonitoring/applyParkByMonitorId', transformParam(params));
};
/**
 * 监控规则-推送岗位组
 */
export const applyJobByMonitorId = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/baseRuleMonitoring/applyJobByMonitorId', transformParam(params));
};
